<pk-navigation-bar *ngIf="showConfigureNavigation"></pk-navigation-bar>
<pk-navigation-bar-poker *ngIf="!showConfigureNavigation"></pk-navigation-bar-poker>
<vn-page-matrix *ngIf="isPublicPage && isPagematrixReady" [content]="content | dsl | async"></vn-page-matrix>

<pk-poker-download-layout *ngIf="!isPublicPage"></pk-poker-download-layout>
<scroll-to-top *ngIf="disableHtmlHeadTag"></scroll-to-top>
